import { APP_NAMESPACE } from 'app/App.constants';

export const COUNTRY_NETWORK_NAMESPACE = `${APP_NAMESPACE}/COUNTRY_NETWORK`;

export const GET_COUNTRY_NETWORK_REQUEST = `${COUNTRY_NETWORK_NAMESPACE}/GET_COUNTRY_NETWORK_REQUEST`;
export const UPDATE_RD_RETURN_FEATURE_REQUEST = `${COUNTRY_NETWORK_NAMESPACE}/UPDATE_RD_RETURN_FEATURE_REQUEST`;
export const UPDATE_MKTP_RETURN_FEATURE_REQUEST = `${COUNTRY_NETWORK_NAMESPACE}/UPDATE_MKTP_RETURN_FEATURE_REQUEST`;
